import { render, staticRenderFns } from "./FairsViewPage.vue?vue&type=template&id=47ec0dc6&scoped=true&"
import script from "./FairsViewPage.vue?vue&type=script&lang=js&"
export * from "./FairsViewPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ec0dc6",
  null
  
)

export default component.exports